/**
 * Takes a generator function and aborts it when called again. To be used along with lodash debounce
 *
 * Example:
 * const simpleFunc = makeSimple(function* (arg1, arg2) {
 *    // ..your code here..
 *    yield anAsyncFunc()
 *    // ..your code here..
 * })
 *
 * const debouncedFn = _.debounce(simpleFunc, 250)
 *
 * @param generator
 */
export default function makeSingle(generator) {
  let globalNonce;
  // eslint-disable-next-line consistent-return
  return async function anonymous(...args) {
    // eslint-disable-next-line no-multi-assign
    const localNonce = (globalNonce = {});

    const iter = generator(...args);
    let resumeValue;
    for (;;) {
      const n = iter.next(resumeValue);
      if (n.done) {
        return n.value; // final return value of passed generator
      }

      // whatever the generator yielded, _now_ run await on it
      // eslint-disable-next-line no-await-in-loop
      resumeValue = await n.value;
      if (localNonce !== globalNonce) {
        return undefined; // a new call was made
      }
      // next loop, we give resumeValue back to the generator
    }
  };
}
